module.exports = __webpack_public_path__ + "img/arrow8.5add5d3b.svg";